import { IAutomaticallyBySetRules } from 'app/library/module/interfaces/automatically-by-set-rules.interface';
import { CompletionRule } from '../enums/completion-rule.enum';

// @dynamic
export class ProgramCompletionRuleOptions {
    static all: IAutomaticallyBySetRules[] = [
        {
            translationLabel: 'PROGRAMS.COMPLETION_RULE.BY_END_DATE',
            value: CompletionRule.AUTO_END_DATE_REACHED,
            isSelected: false,
        },
        {
            translationLabel: 'PROGRAMS.COMPLETION_RULE.BY_ALL_COURSES',
            value: CompletionRule.AUTO_COMPLETE_ALL_COURSES,
            isSelected: false,
        },
        {
            translationLabel: 'PROGRAMS.COMPLETION_RULE.BY_CERTIFICATE',
            value: CompletionRule.AUTO_RECEIVE_CERTIFICATE,
            isSelected: false,
        },
        {
            translationLabel: 'PROGRAMS.COMPLETION_RULE.BY_PASSING_GRADE',
            value: CompletionRule.AUTO_ACHIEVE_PASSING_GRADE,
            isSelected: false,
        },
    ];
}
